import { useCallback, useEffect, useRef, useState } from 'react';
import { getConsentStats, type ConsentStats } from '../api/admin';

const POLL_INTERVAL_MS = 30_000;

export function useConsentStats() {
  const [stats, setStats] = useState<ConsentStats | null>(null);
  const [loading, setLoading] = useState(true);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getConsentStats();
      setStats(res.data.data);
    } catch {
      // keep stale data on error — don't blank out the widget
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    timerRef.current = setInterval(() => { refresh(); }, POLL_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [refresh]);

  return { stats, loading, refresh };
}
